import React from "react";

const MESSAGES = {
  candidate: {
    heading: "Thank You for Attending the Interview",
    body: "We appreciate the time and effort you dedicated to this session. Our team will carefully review your responses and reach out to you with the next steps shortly.",
    close: "You may now safely close this window.",
  },
  recruiter: {
    heading: "Interview Session Concluded",
    body: "Thank you for conducting this interview session. The candidate's responses have been recorded and are ready for your review in the dashboard.",
    close: "You may now safely close this window.",
  },
  panelist: {
    heading: "Thank You for Joining as a Panelist",
    body: "Your expertise and insights during this session are greatly valued. We appreciate the time and effort you contributed toward evaluating the candidate.",
    close: "You may now safely close this window.",
  },
};

const HybridVideoInterviewThankYou = ({ role }) => {
  const content = MESSAGES[role] || {
    heading: "Session Ended",
    body: "Thank you for your participation. The session has been completed successfully.",
    close: "You may now safely close this window.",
  };

  return (
    <div className="thankyou-wrapper">
      <div className="thankyou-card">
        <img src="/images/gappeoai-logo.png" alt="Gappeo AI" className="thankyou-logo" />
        <div className="thankyou-icon">
          <svg viewBox="0 0 24 24" fill="none" width="56" height="56">
            <circle cx="12" cy="12" r="11" stroke="#02c573" strokeWidth="2" />
            <path
              d="M7 12.5l3.5 3.5 6.5-7"
              stroke="#02c573"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2 className="thankyou-heading">{content.heading}</h2>
        <p className="thankyou-body">{content.body}</p>
        <p className="thankyou-close">{content.close}</p>
      </div>
    </div>
  );
};

export default HybridVideoInterviewThankYou;
